import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NewUserPageRoutingModule } from './new-user-routing.module';
import { NewUserPage } from './new-user.page';
import { RegisterCompanyFormComponent } from './register-company-form/register-company-form.component';
import { RegisterFormComponent } from './register-form/register-form.component';
import { RegisterPersonalFormComponent } from './register-personal-form/register-personal-form.component';

@NgModule({
  imports: [SharedModule, NewUserPageRoutingModule],
  declarations: [
    NewUserPage,
    RegisterPersonalFormComponent,
    RegisterCompanyFormComponent,
    RegisterFormComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NewUserPageModule {}
